<!-- ============================================================
     MOBILE BOTTOM NAVIGATION BAR  —  only visible < 992px
  ============================================================ -->

<!-- Backdrop — closes submenu on outside tap -->
<div
    class="bnav-backdrop"
    *ngIf="openSubmenu"
    (click)="closeSubmenu()"
></div>

<!-- Submenu sheet — slides up above the bar when a parent is tapped -->
<div class="bnav-submenu-sheet" [class.open]="openSubmenu !== null" *ngIf="openSubmenu">
    <div class="bnav-submenu-handle" (click)="closeSubmenu()">
        <span class="handle-bar"></span>
    </div>
    <p class="bnav-submenu-title">{{ openSubmenu?.label }}</p>
    <div class="bnav-submenu-list">
        <button
            *ngFor="let child of openSubmenu?.children"
            class="bnav-submenu-item"
            [class.active]="child.routerLink && activeRoute.startsWith(child.routerLink)"
            (click)="navigate(child.routerLink!)"
        >
            <span class="bnav-submenu-icon">
                <span [class]="child.icon" class="bnav-icon"></span>
            </span>
            <span class="bnav-submenu-label">{{ child.label }}</span>
            <i class="pi pi-chevron-right bnav-submenu-arrow"></i>
        </button>
    </div>
</div>

<!-- Bottom nav bar -->
<nav class="bnav-bar" aria-label="Mobile navigation">
    <button
        *ngFor="let item of allItems"
        class="bnav-item"
        [class.active]="isActive(item)"
        [class.has-submenu]="item.children?.length"
        [class.submenu-open]="openSubmenu === item"
        (click)="onItemTap(item)"
        [attr.aria-label]="item.label"
        [attr.aria-haspopup]="item.children?.length ? 'true' : null"
        [attr.aria-expanded]="openSubmenu === item ? 'true' : null"
        [attr.aria-current]="isActive(item) ? 'page' : null"
    >
        <!-- Icon bubble -->
        <span class="bnav-icon-bubble">
            <span [class]="item.icon" class="bnav-icon"></span>
        </span>
        <!-- Label + chevron for parents -->
        <span class="bnav-label">
            {{ item.label }}
            <i *ngIf="item.children?.length" class="pi pi-angle-up bnav-chevron" [class.rotated]="openSubmenu === item"></i>
        </span>
    </button>
</nav>
